import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'echexpayment-admininvoice',
  templateUrl: './admininvoice.component.html',
  styleUrls: ['./admininvoice.component.css']
})
export class AdmininvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/admininvoice/admininvoice.component.ts